module.exports = __webpack_public_path__ + "static/media/calendar.bfd68b0c.svg";